(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["a-10l-packages"] && !Shopify.designMode) return;
  try {
    
	const defineS10lPackages = () => {
		if (customElements.get('l-s10l-packages')) {
			return
		}

		class LS10lPackages extends HTMLElement {
			connectedCallback() {
				this._mediaItems = [...this.querySelectorAll('[data-package-media]')]
				this._contentItems = [...this.querySelectorAll('[data-package-content]')]

				if (!this._mediaItems.length || !this._contentItems.length) {
					return
				}

				this._contentItems.forEach((item, index) => {
					item.addEventListener('mouseenter', () => this._setActive(index))
					item.addEventListener('focusin', () => this._setActive(index))
				})

				this._setActive(0)
			}

			_setActive(index) {
				this._mediaItems.forEach((element, itemIndex) => {
					element.classList.toggle('is-active', itemIndex === index)
				})

				this._contentItems.forEach((element, itemIndex) => {
					element.classList.toggle('is-active', itemIndex === index)
				})
			}
		}

		customElements.define('l-s10l-packages', LS10lPackages)
	}

	defineS10lPackages()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
	if (!customElements.get('faq-search-filter')) {
		class FaqSearchFilter extends HTMLElement {
			connectedCallback() {
				this._input = this.querySelector('input[type="search"]')
				this._root = this.closest('[data-faq-search]')
				this._items = this._root?.querySelectorAll('[data-faq-search-item]') ?? []
				this._empty = this._root?.querySelector('[data-faq-search-empty]')

				this._input?.addEventListener('input', this._onInput)
			}

			disconnectedCallback() {
				this._input?.removeEventListener('input', this._onInput)
			}

			_onInput = () => {
				const query = this._input.value.trim().toLowerCase()
				let visibleCount = 0

				this._items.forEach((item) => {
					const title = (item.getAttribute('data-search-title') || '').toLowerCase()
					const content = (item.getAttribute('data-search-content') || '').toLowerCase()
					const matches = query === '' || title.includes(query) || content.includes(query)

					item.hidden = !matches

					if (matches) {
						visibleCount += 1
					}
				})

				const groups = this._root?.querySelectorAll('[data-faq-search-group]') ?? []

				groups.forEach((group) => {
					if (query === '') {
						group.hidden = false
						return
					}

					const hasVisibleItem = [...group.querySelectorAll('[data-faq-search-item]')].some((item) => !item.hidden)

					group.hidden = !hasVisibleItem
				})

				if (this._empty) {
					this._empty.hidden = query === '' || visibleCount > 0
				}
			}
		}

		customElements.define('faq-search-filter', FaqSearchFilter)
	}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["media-grid"] && !Shopify.designMode) return;
  try {
    
	const defineBrewingSupportVideoDialog = async () => {
		if (customElements.get('l-media-grid-video')) {
			return
		}

		await customElements.whenDefined('dialog-element')

		const DialogElement = customElements.get('dialog-element')

		class BrewingSupportVideoDialog extends DialogElement {
			constructor() {
				super()
			}

			connectedCallback() {
				super.connectedCallback()
				this.querySelector('.l-sMGrid-video-dialog__backdrop')?.addEventListener('click', this._onBackdropClick, {
					signal: this._abortController.signal,
				})
				this.addEventListener('dialog:after-show', this._onAfterShow)
				this.addEventListener('dialog:after-hide', this._onAfterHide)
			}

			_onBackdropClick = () => {
				this.hide()
			}

			get shouldLock() {
				return true
			}

			get shouldAppendToBody() {
				return true
			}

			get initialFocus() {
				return false
			}

			_onToggleClicked(event) {
				event?.preventDefault()

				if (this.open) {
					this.hide()
					return
				}

				this.show('immediate')
				this._playVideo()
			}

			hide() {
				this._pauseVideo()
				return super.hide()
			}

			show(animate = true) {
				const result = super.show(animate)

				if (this.open) {
					this._playVideo()
				}

				return result
			}

			_onAfterShow = () => {
				this._playVideo()
			}

			_playVideo() {
				this.querySelectorAll('video-media[host] iframe').forEach((iframe) => {
					const originalSrc = iframe.getAttribute('data-original-src')

					if (originalSrc && iframe.src !== originalSrc) {
						iframe.src = originalSrc
					}
				})

				const videoMedia = this.querySelector('video-media')

				if (!videoMedia) {
					this.querySelector('video')?.play?.()
					return
				}

				const startPlayback = () => {
					if (typeof videoMedia.play === 'function') {
						videoMedia.play({ restart: true })
					}
				}

				this._playbackObserver?.disconnect()

				if (videoMedia.hasAttribute('can-play')) {
					startPlayback()
					return
				}

				startPlayback()

				this._playbackObserver = new MutationObserver(() => {
					if (!videoMedia.hasAttribute('can-play')) {
						return
					}

					this._playbackObserver?.disconnect()
					this._playbackObserver = null
					startPlayback()
				})

				this._playbackObserver.observe(videoMedia, { attributes: true, attributeFilter: ['can-play'] })
			}

			_pauseVideo() {
				this._playbackObserver?.disconnect()
				this._playbackObserver = null

				this.querySelectorAll('video-media').forEach((videoMedia) => {
					if (videoMedia.playing && typeof videoMedia.pause === 'function') {
						videoMedia.pause()
					} else if (videoMedia.hasAttribute('host') && videoMedia.player?.pause) {
						videoMedia.player.pause()
					}

					videoMedia.removeAttribute('playing')
				})

				this.querySelectorAll('video').forEach((video) => {
					video.pause()
					video.currentTime = 0
				})

				this.querySelectorAll('video-media[host] iframe').forEach((iframe) => {
					if (!iframe.src || iframe.src === 'about:blank') {
						return
					}

					iframe.setAttribute('data-original-src', iframe.src)
					iframe.src = 'about:blank'
				})
			}

			_onAfterHide = () => {
				this._pauseVideo()
			}
		}

		customElements.define('l-media-grid-video', BrewingSupportVideoDialog)
	}

	defineBrewingSupportVideoDialog()

  } catch(e) { console.error(e); }
})();
})();
